import PropTypes from "prop-types";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";
import styled from "styled-components";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function Component(props: any) {
  const { className, title } = props;
  return <span className={className}>{title}</span>;
}

export const Title = styled(Component)`
  margin-left: 5px;
`;

Title.propTypes = {
  title: PropTypes.string.isRequired,
};
